/**
 * @generated SignedSource<<c9203ae2743641cae6ebf93c253edd91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AttributeConditionOperator = "EQUALS" | "EXISTS" | "%future added value";
export type UpdateMailingListCriterionInput = {
  criterion: MembershipCriterionInput;
  id: string;
};
export type MembershipCriterionInput = {
  conditions: ReadonlyArray<AttributeConditionInput>;
};
export type AttributeConditionInput = {
  attributeName: string;
  operator: AttributeConditionOperator;
  value?: string | null | undefined;
};
export type EditMailingListCriterionDialogMutation$variables = {
  input: UpdateMailingListCriterionInput;
};
export type EditMailingListCriterionDialogMutation$data = {
  readonly updateMailingListCriterion: {
    readonly criterion: {
      readonly conditions: ReadonlyArray<{
        readonly attributeName: string;
        readonly operator: AttributeConditionOperator;
        readonly value: string | null | undefined;
      }>;
    } | null | undefined;
    readonly id: string;
    readonly subscribedCount: number;
    readonly unsubscribedCount: number;
  };
};
export type EditMailingListCriterionDialogMutation = {
  response: EditMailingListCriterionDialogMutation$data;
  variables: EditMailingListCriterionDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MailingList",
    "kind": "LinkedField",
    "name": "updateMailingListCriterion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subscribedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unsubscribedCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MembershipCriterion",
        "kind": "LinkedField",
        "name": "criterion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AttributeCondition",
            "kind": "LinkedField",
            "name": "conditions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "attributeName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "operator",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMailingListCriterionDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMailingListCriterionDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e412b00b9ea79d5b46892be40311f570",
    "id": null,
    "metadata": {},
    "name": "EditMailingListCriterionDialogMutation",
    "operationKind": "mutation",
    "text": "mutation EditMailingListCriterionDialogMutation(\n  $input: UpdateMailingListCriterionInput!\n) {\n  updateMailingListCriterion(input: $input) {\n    id\n    subscribedCount\n    unsubscribedCount\n    criterion {\n      conditions {\n        attributeName\n        operator\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5d017c8a1becb28a6332ce05c90698f";

export default node;
